import { ExternalLink, Globe } from "lucide-react";

import { EXTERNAL_LINKS } from "@/config/externalLinks";

export function Footer() {
  return (
    <footer className="relative z-10 border-t border-[var(--color-border)] bg-[var(--color-bg)]">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-8">
        <div className="flex flex-wrap items-center gap-4 text-xs">
          <p className="text-[var(--color-ink-soft)]">© 2026 invest_aitech · PPTX JSON Studio</p>
          <a
            href={EXTERNAL_LINKS.homepage.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-[var(--color-ink-muted)] hover:text-[var(--color-coral)] hover:underline"
          >
            <Globe size={12} />
            {EXTERNAL_LINKS.homepage.label}
            <ExternalLink size={10} />
          </a>
        </div>
        <div className="flex flex-wrap gap-4 text-xs">
          {EXTERNAL_LINKS.qiita.map((link) => (
            <a
              key={link.url}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-[var(--color-ink-muted)] hover:text-[var(--color-ink)] hover:underline"
            >
              {link.title}
              <ExternalLink size={12} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
